import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Modal, message, Collapse, Tag } from "antd";
import { usrRole } from "../../utils/dataUtil";

import {
  getSSPAcademicYear,
  formateDateDbT_YMD,
  formateDate_YMD,
} from "../../utils/dateUtil";

import {
  req_list_ssp_school_junior_customize,
  req_delete_ssp_school_junior_customize,
  req_edit_ssp_school_junior_customize,
  req_add_ssp_school_junior_customize,
} from "../../api";
import "./student-department-senior-manage-list.css";
const { Panel } = Collapse;
class SchoolJuniorCustomizeModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "NONE",
    searchValue: "",
    data: [],
    row: {
      Gid: "",
      SourceCreatorId: "",
      CountyCityCode: "",
      CountyCityName: "",
      HighSchoolTwName: "",
    },
    obj: {},
    searchVal: "",
    inputHighSchoolTwName: "",
    selectedCountyCityName: "生源縣市",
    selectedCountyCityValue: "NONE",
    todayYMD: formateDate_YMD(new Date()),
    countyCities: [
      { value: "NONE", key: "NONE", label: "生源縣市" },
      { value: "30", key: "30", label: "臺北市" },
      { value: "01", key: "01", label: "新北市" },
      { value: "17", key: "17", label: "基隆市" },
      { value: "02", key: "02", label: "宜蘭縣" },
      { value: "15", key: "15", label: "花蓮縣" },
      { value: "14", key: "14", label: "臺東縣" },
      { value: "03", key: "03", label: "桃園市" },
      { value: "18", key: "18", label: "新竹市" },
      { value: "04", key: "04", label: "新竹縣" },
      { value: "05", key: "05", label: "苗栗縣" },
      { value: "06", key: "06", label: "臺中市" },
      { value: "07", key: "07", label: "彰化縣" },
      { value: "08", key: "08", label: "南投縣" },
      { value: "09", key: "09", label: "雲林縣" },
      { value: "20", key: "20", label: "嘉義市" },
      { value: "10", key: "10", label: "嘉義縣" },
      { value: "11", key: "11", label: "臺南市" },
      { value: "12", key: "12", label: "高雄市" },
      { value: "13", key: "13", label: "屏東縣" },
      { value: "71", key: "71", label: "金門縣" },
      { value: "72", key: "72", label: "連江縣" },
      { value: "16", key: "16", label: "澎湖縣" },
    ],
  };

  componentWillMount() {
    this.api_list_source();
  }

  ////////////////////////////////////////
  api_list_source = async () => {
    const { planAcademicYear, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [], loading: true });
    const result = await req_list_ssp_school_junior_customize(
      userCode,
      userLevel,
      planAcademicYear,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
    } else {
      const items = [];
      this.setState({ data: items, loading: false });
    }
  };

  api_list_source_noloading = async () => {
    const { planAcademicYear, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [] });
    const result = await req_list_ssp_school_junior_customize(
      userCode,
      userLevel,
      planAcademicYear,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      const items = [];
      this.setState({
        data: items,
      });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_ssp_school_junior_customize(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  api_edit_item = async (row) => {
    const { token, userCode } = this.props.user;
    row.RecordEditorId = userCode;
    await req_edit_ssp_school_junior_customize(row, token);
    this.handle_data_refresh();
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_ssp_school_junior_customize(item, token);
    if (result.status === "success") {
      this.handle_data_refresh();
      //  message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  ////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_list_source();
  };

  handle_show_ui_modal = (modal, item) => {
    const { Gid } = item;
    switch (modal) {
      case "add":
        this.handle_data_refresh();
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆機構`,
          onOk: () => {
            this.api_delete_item(Gid);
          },
        });
        break;
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const { userCode } = this.props.user;
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        Gid: target_key,
        NumberOfPeople: getValue,
        NumberConfident: getValue,
        RecordEditorId: userCode,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_edit_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  ////////////////////////////////////////

  handleInputHighSchoolChange = (event) => {
    const value = event.target.value;
    this.setState({
      inputHighSchoolTwName: value,
    });
  };

  handleSelectedCountyCityChange = (event) => {
    const value = event.target.value;
    const { countyCities } = this.state;
    const countyCity = countyCities.find(function (item, index, array) {
      return item.value === value;
    });
    if (countyCity) {
      this.setState({
        selectedCountyCityValue: value,
        selectedCountyCityName: countyCity.label,
      });
    }
  };

  handleSave = (event) => {
    event.preventDefault();
    const {
      planAcademicYear,
      selectedCountyCityName,
      selectedCountyCityValue,
      inputHighSchoolTwName,
      row,
    } = this.state;

    const errors = [];

    if (selectedCountyCityName === "生源縣市") {
      errors.push("生源縣市未選");
    }
    if (inputHighSchoolTwName === "") {
      errors.push("生源機構名稱未填");
    }

    if (errors.length === 0) {
      row.SourceCreatorId = this.props.user.userCode;
      row.PlanAcademicYear = planAcademicYear;
      row.CountyCityCode = selectedCountyCityValue;
      row.CountyCityName = selectedCountyCityName;
      row.HighSchoolTwName = inputHighSchoolTwName;
      console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  };

  render() {
    const {
      planAcademicYear,
      data,
      loading,
      HighSchoolTwName,
      selectedCountyCityValue,
      todayYMD,
    } = this.state;
    const columns = [
      {
        title: "",
        width: "50px",
        render: (item) => {
          const { AddTotal } = item;
          return (
            <>
              {AddTotal === 0 ? (
                <button
                  className="btn btn-dark btn-sm"
                  style={{ width: "82px" }}
                  onClick={() => this.handle_show_ui_modal("delete", item)}
                >
                  <i className="fas fa-trash-alt"></i> 刪除
                </button>
              ) : (
                <Tag color="orange">使用中</Tag>
              )}
            </>
          );
        },
      },
      {
        title: "生源縣市",
        align: "center",
        dataIndex: "CountyCityName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#90ee90"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源機構",
        dataIndex: "HighSchoolTwName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#90ee90"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];

    return (
      <>
        <div>
          <Input
            placeholder="規劃年度"
            style={{
              width: 55,
              height: 39,
              margin: "0 5px",
              color: "red",
            }}
            onChange={(event) =>
              this.setState({ planAcademicYear: event.target.value })
            }
            value={planAcademicYear}
            readOnly={true}
            disabled={true}
          />
        </div>
        <p></p>
        <div className="form-group">
          <Collapse>
            <Panel header="新增單筆" key="1">
              <>
                <form onSubmit={this.handleSave} className="form-inline">
                  {" "}
                  <select
                    className="form-control"
                    style={{
                      width: 120,
                      backgroundColor: "LightCyan",
                      display: "inline-block",
                    }}
                    onChange={this.handleSelectedCountyCityChange}
                    value={selectedCountyCityValue}
                  >
                    <option value="NONE" key="NONE">
                      生源縣市
                    </option>
                    <option value="30" key="30">
                      臺北市
                    </option>
                    <option value="01" key="01">
                      新北市
                    </option>
                    <option value="17" key="17">
                      基隆市
                    </option>
                    <option value="02" key="02">
                      宜蘭縣
                    </option>
                    <option value="15" key="15">
                      花蓮縣
                    </option>
                    <option value="14" key="14">
                      臺東縣
                    </option>
                    <option value="03" key="03">
                      桃園市
                    </option>
                    <option value="18" key="18">
                      新竹市
                    </option>
                    <option value="04" key="04">
                      新竹縣
                    </option>
                    <option value="05" key="05">
                      苗栗縣
                    </option>
                    <option value="06" key="06">
                      臺中市
                    </option>
                    <option value="07" key="07">
                      彰化縣
                    </option>
                    <option value="08" key="08">
                      南投縣
                    </option>
                    <option value="09" key="09">
                      雲林縣
                    </option>
                    <option value="20" key="20">
                      嘉義市
                    </option>
                    <option value="10" key="10">
                      嘉義縣
                    </option>
                    <option value="11" key="11">
                      臺南市
                    </option>
                    <option value="12" key="12">
                      高雄市
                    </option>
                    <option value="13" key="13">
                      屏東縣
                    </option>
                    <option value="71" key="71">
                      金門縣
                    </option>
                    <option value="72" key="72">
                      連江縣
                    </option>
                    <option value="16" key="16">
                      澎湖縣
                    </option>
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      width: "200px",
                      backgroundColor: "LightYellow",
                      display: "inline-block",
                    }}
                    name="HighSchoolTwName"
                    id="HighSchoolTwName"
                    defaultValue={HighSchoolTwName}
                    placeholder="請輸入生源機構名稱"
                    onChange={this.handleInputHighSchoolChange}
                  />
                  <button
                    type="submit"
                    className={"btn btn-info"}
                    style={{
                      marginLeft: "2px",
                      marginBottom: "6px",
                    }}
                  >
                    <i className="fa fa-plus"></i>
                  </button>
                </form>
              </>
            </Panel>
          </Collapse>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SchoolJuniorCustomizeModal);
